//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function loadTagsUserService(id) {
    try {
        const response = await api.get(`/leads/${id}/tags`);
        return response;
    } catch {
        toast.error("Erro ao buscar tags do lead");
        return null;
    }
}